package one.healthium.log_food.ui.add_food

import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import kotlin.time.Clock
import kotlin.time.Instant

internal data class AddFoodUiState(
    val loading: Boolean = false,
    val currentAmount: AmountUiModel? = null,
    val currentFood: FoodUiModel? = null,
    val selectedDate: Instant = Clock.System.now(),
    val foodAdded: Boolean = false,
) {
    val options = if (currentAmount != null && currentFood != null) {
        FoodUiOptions(currentAmount, currentFood, selectedDate)
    } else {
        null
    }
}
